export const environment = {
    production: false,
    backendBaseUrl: "https://sso.test.satsang.org.in",
    // backendBaseUrl: "http://localhost:6061",
    orgUrl: 'https://www.test.satsang.org.in/signin-load?login=true',
    npOrgUrl: 'https://satsangnepal.org.np/',
    accoUrl: 'https://dev.acco.satsang.org.in',
    onlineIvUrl: 'https://oblation.test.satsang.org.in',
    loginRule: {

        'IN': {
            accounts: ['Phone Number', 'Family Code', 'Sl. Number'],
            createAccount: true
        },

        // 'EU': {
        //     accounts: ['Family Code', 'Email'],
        //     createAccount: false
        // },
        'NE': {
            accounts: ['Family Code'],
            createAccount: false
        }
    },
    allowedPassword: ['NE']
};
